import * as Stores from '../stores'

export function useBenefitsEnrollments() {
  const benefitsEnrollments = Stores.CardBenefitsApi.endpoints[
    'GET /benefits/enrollments'
  ].useQuery(
    {},
    {
      selectFromResult({ data, isLoading, isUninitialized, isSuccess, error }) {
        return {
          isUninitialized,
          isLoading,
          isSuccess,
          error,
          data: data?.benefitEnrollments ? data.benefitEnrollments : undefined,
        }
      },
    },
  )

  return benefitsEnrollments
}
